import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import ProgressBar from '../ProgressBar';
import PageWrapper from '../Utility/PageWrapper';
import SVGIcon from '../SVGIcon';
import VerticalSpacing from '../Utility/VerticalSpacing/VerticalSpacing';
import Grid from '../Utility/Grid/Grid';
import Text from '../BuildingBlocks/Text/Text';

import PageSEO from '../PageSEO';

import bookingProgress from '../../constants/messages/bookingProgress';

class BookingNoPermission extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    policies: PropTypes.shape({}).isRequired,
    routes: PropTypes.shape({}).isRequired
  };

  constructor(props) {
    super(props);

    this.handleClickRoomAssignments = this.handleClickRoomAssignments.bind(this);
    this.handleClickRoomSchedule = this.handleClickRoomSchedule.bind(this);
    this.handleClickSummary = this.handleClickSummary.bind(this);
    this.handleClickPayment = this.handleClickPayment.bind(this);
  }

  buildProgressBar() {
    const { intl, policies } = this.props;
    return [
      {
        label: intl.formatMessage(bookingProgress.stepRoomSchedules),
        onClick: policies.canAccessRoomAssignments || policies.canAccessSchedule ? this.handleClickRoomSchedule : null
      },
      {
        label: intl.formatMessage(bookingProgress.stepPayment),
        onClick: policies.canSubmitPayment ? this.handleClickPayment : undefined
      },
      {
        label: intl.formatMessage(bookingProgress.stepSummary),
        onClick: policies.canFinalizeBooking || policies.canEditGuestInformation ? this.handleClickSummary : undefined
      }
    ];
  }

  handleClickRoomAssignments() {
    const { routes } = this.props;
    const { gotoRoomAssignments } = routes;
    gotoRoomAssignments();
  }

  handleClickRoomSchedule() {
    const { routes } = this.props;
    const { gotoRoomSchedule } = routes;
    gotoRoomSchedule();
  }

  handleClickPayment() {
    const { routes } = this.props;
    const { gotoPayment } = routes;
    gotoPayment();
  }

  handleClickSummary() {
    const { routes } = this.props;
    const { gotoSummary } = routes;
    gotoSummary();
  }

  render() {
    return (
      <PageWrapper>
        {/* SEO */}
        <PageSEO title="Missing User Permission - LodgeLink" />

        <ProgressBar hideBackButton progressItems={this.buildProgressBar()} />
        <Grid.Container>
          <Grid.Row align="center">
            <Grid.Col md={8} push={{ md: 2 }}>
              <VerticalSpacing>
                <div style={{ marginBottom: '50px', display: 'flex', justifyContent: 'center' }}>
                  <SVGIcon selectedIcon="projects" />
                </div>
                <Text.HeadingFirst tagName="h2" color="quaternary" align="center" noMargins>
                  Missing Booking Permission(s)
                </Text.HeadingFirst>
                <Text.CopyBody tagName="p" align="center">
                  You currently do not have the required permissions to view this stage of the booking flow. Please
                  ensure all prior steps of the booking have been sufficiently completed.
                </Text.CopyBody>
                <Text.CopyBody tagName="p" align="center">
                  If you think this is a mistake, please check with your organization administrators or contact
                  LodgeLink for additional support.
                </Text.CopyBody>
              </VerticalSpacing>
            </Grid.Col>
          </Grid.Row>
        </Grid.Container>
      </PageWrapper>
    );
  }
}

export default injectIntl(BookingNoPermission);
